import React from 'react';
import core, { App } from '@gin-betting/core';
import cd from 'debug';

import { ParentPath } from 'types';
import GameLogo from '../GameLogo';
import SmartLink from '../SmartLink';

import './tournamentName.scss';

const debug = cd('components:TournamentName');

const {
    utils: { checkOnRoute },
} = core;

interface Props {
    tournamentName: string;
    masterId: string;
    sportId: string;
    slug: string;
    route: ParentPath;
    isDisabled?: boolean;
}

const TournamentName: React.FC<Props> = props => {
    debug('render', props);
    const { tournamentName, sportId, slug, isDisabled, route } = props;
    const isLinkDisabled =
        checkOnRoute(App.Routes.TOURNAMENT) ||
        checkOnRoute(App.Routes.RESULTS_LIST) ||
        isDisabled;

    const linkToTournament = `${route}${App.Routes.TOURNAMENT}${slug}`;

    return (
        <div styleName="container" className="__app-TournamentName-container">
            <GameLogo gameId={sportId} />
            {isLinkDisabled ? (
                <div styleName="name" className="__app-TournamentName-name">
                    <span title={tournamentName}>{tournamentName}</span>
                </div>
            ) : (
                <SmartLink
                    to={linkToTournament}
                    styleName="name"
                    className="__app-TournamentName-name"
                >
                    <span title={tournamentName}>{tournamentName}</span>
                </SmartLink>
            )}
        </div>
    );
};

export default TournamentName;
